'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageId = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getWelcomeMessage = require('./getWelcomeMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMessageId = exports.getMessageId = (0, _reselect.createSelector)(_getWelcomeMessage.getWelcomeMessage, (0, _get2.default)('id'));


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getMessageId.js
// module id = 202
// module chunks = 2 3